// extracted by mini-css-extract-plugin
export default {"Title":"ArticleInfo_Title__UDDYr"};